import { ReactElement, useState } from 'react'
import { SearchProps } from './props'
import { StyledSearch } from './styles'
import { Input, SVG } from '../../Atoms'
import { SVGs } from '../..'

const Search = ({ onChange, placeholder }: SearchProps): ReactElement => {
    const [searchValue, setSearchValue] = useState('')

    const newSearchValue = (value: string) => {
        onChange(value)
        setSearchValue(value)
    }

    return (
        <StyledSearch>
            <SVG
                src={SVGs.Search}
                css={{ left: '$3', pointerEvents: 'none' }}
            />
            <Input
                placeholder={placeholder}
                onChange={(e) => {
                    newSearchValue(e.target.value)
                }}
                value={searchValue}
            />
            {searchValue.length > 0 && (
                <SVG
                    css={{ right: '$3', '&:hover': { color: '$neutral500' } }}
                    src={SVGs.CloseCircleRegular}
                    onClick={() => newSearchValue('')}
                />
            )}
        </StyledSearch>
    )
}

export default Search
export { StyledSearch }
